import React, { Component } from 'react';
import Slider from '@material-ui/core/Slider';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
var _ = require('lodash');

function valuetext(value) {
  return `${value} €`;
}
const useStyles = makeStyles({
  root: {
    width: 300,
  },
});
export default class Amount extends Component {
  constructor(props) {
    super(props);
    this.change = _.debounce(this.change.bind(this), 500)
    this.updateManual = _.debounce(this.updateManual.bind(this), 500)
    this.changeManual  = this.changeManual.bind(this)
    this.state = {
      amount: this.props.degat.amount/100.0,
      max: (this.props.degat.montant_max)/100.0,
      min: this.props.degat.montant_min/100.0,
      input: false,

    };
  }
  change(e,value){
    value = parseInt(value)*100
    let degat = this.props.degat
    degat["amount"] = value
    this.props.onChange(degat)
  }
  changeManual(e){
    this.setState({amount: e.target.value})
    this.updateManual()
  }
  updateManual(){
    let value = this.state.amount*100
    let degat = this.props.degat
    degat["amount"] = value
    this.props.onChange(degat)
  }

  render() {
    if(this.props.degat.montant_max==this.props.degat.montant_min){
      if(this.state.input){
        return(
          <div>
            <input type="number" value={this.state.amount} onChange={this.changeManual}/>
          </div>
          )
      }else{
        return (
          <div onClick={(e)=>this.setState({input: true})}>
            {this.props.degat.amount/100.0} €
          </div>
        );
      }
    }else{
      return(
        <div>
        <Slider
        defaultValue={this.state.amount}
        getAriaValueText={valuetext}
        aria-labelledby="discrete-slider"
        onChange={this.change}
        valueLabelDisplay="on"
        step={(this.state.max-this.state.min)/10}
        marks
        min={this.state.min}
        max={this.state.max}
        />
        </div>
        )
    }
  }
}
